import React from 'react';
import { Disclosure } from '@headlessui/react'

import {PlusIcon} from "../icons";
import clsx from "clsx";
const Collapse = ({ title, description, className }: { title: string; description: string; className?:  string; }) => {
  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={clsx(
              "w-full text-left py-[28px] px-4 flex items-center justify-between mx-auto text-[20px] leading-[22px] font-medium",
              className
            )}
          >
            <p className="lg:max-w-[70%]">{title}</p>
            <PlusIcon className={open ? 'rotate-45 transform duration-150 easy-in' : ''} />
          </Disclosure.Button>
          <Disclosure.Panel className="py-[28px] px-4 text-left ext-[20px] leading-[22px] font-medium whitespace-pre-line">
            {description}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
};

export default Collapse;
